const METAS = {
  "/": {
    title: "Fondation HORA — Le savoir juridique et fiscal, accessible à tous",
    description: "La Fondation HORA démocratise l'accès à l'éducation, à l'expertise spécialisée, aux ressources et au soutien financier au Québec.",
  },
  "/a-propos": {
    title: "À propos — Fondation HORA",
    description: "Découvrez la mission, la vision, la gouvernance et le conseil d'administration de la Fondation HORA.",
  },
  "/formations": {
    title: "Formations juridiques et fiscales — Fondation HORA",
    description: "Formations gratuites, payantes et rediffusions pour entrepreneurs, travailleurs autonomes et organisations au Québec.",
  },
  "/bourses": {
    title: "Bourses — Fondation HORA",
    description: "Programmes de bourses et critères d'admissibilité de la Fondation HORA.",
  },
  "/plan-action": {
    title: "Plan d'action 2025-2026 — Fondation HORA",
    description: "Consultez les orientations, objectifs et mesures du plan d'action 2025-2026 de la Fondation HORA.",
  },
  "/blogue": {
    title: "Blogue juridique et entrepreneurial — Fondation HORA",
    description: "Articles et analyses juridiques, fiscales et entrepreneuriales rédigés pour rendre l'expertise accessible.",
  },
  "/contact": {
    title: "Contact — Fondation HORA",
    description: "Contactez la Fondation HORA à Montréal pour une formation, un partenariat, du bénévolat ou une question.",
  },
  "/don": {
    title: "Faire un don — Fondation HORA",
    description: "Soutenez l'inclusion économique et l'accès à l'expertise juridique et fiscale en faisant un don à la Fondation HORA.",
  },
  "/impact": {
    title: "Notre impact — Fondation HORA",
    description: "Rapport annuel, statistiques, activités antérieures et frise des 27 événements organisés depuis 2021.",
  },
  "/devenir-partenaire": {
    title: "Devenir partenaire — Fondation HORA",
    description: "Collaborez avec la Fondation HORA pour soutenir l'inclusion économique et la résilience entrepreneuriale.",
  },
  "/devenir-benevole": {
    title: "Devenir bénévole — Fondation HORA",
    description: "Mettez votre expertise juridique, fiscale ou entrepreneuriale au service de la communauté.",
  },
  "/conditions-utilisation": {
    title: "Conditions d'utilisation — Fondation HORA",
    description: "Conditions régissant l'utilisation du site et des services de la Fondation HORA.",
  },
  "/politique-confidentialite": {
    title: "Politique de confidentialité — Fondation HORA",
    description: "Renseignements sur la collecte, l'utilisation et la protection des renseignements personnels.",
  },
  "/desabonnement": {
    title: "Désabonnement — Fondation HORA",
    description: "Confirmation de désabonnement de l'infolettre.",
    noindex: true,
  },
};

const ADMIN_META = {
  title: "Administration — Fondation HORA",
  description: "Espace administrateur sécurisé.",
  noindex: true,
};

const BLOG_ARTICLE_META = {
  title: "Article — Blogue de la Fondation HORA",
  description: "Article juridique, fiscal ou entrepreneurial publié par la Fondation HORA.",
};

const setNamedMeta = (name, content) => {
  let tag = document.head.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const setPropertyMeta = (property, content) => {
  let tag = document.head.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

export const applyPageMeta = ({ title, description, path = window.location.pathname, noindex = false }) => {
  const url = `${window.location.origin}${path}`;
  document.title = title;
  setNamedMeta("description", description);
  setNamedMeta("robots", noindex ? "noindex,nofollow" : "index,follow");
  setPropertyMeta("og:title", title);
  setPropertyMeta("og:description", description);
  setPropertyMeta("og:url", url);
  setNamedMeta("twitter:title", title);
  setNamedMeta("twitter:description", description);

  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", url);
};

export const applyJsonLd = (id, data) => {
  const sel = `script[data-jsonld="${id}"]`;
  let tag = document.head.querySelector(sel);
  if (!data) {
    if (tag) tag.remove();
    return;
  }
  if (!tag) {
    tag = document.createElement("script");
    tag.setAttribute("type", "application/ld+json");
    tag.setAttribute("data-jsonld", id);
    document.head.appendChild(tag);
  }
  tag.textContent = JSON.stringify(data);
};

export const routeMeta = (pathname) => {
  // Espace admin : URL discrète (voir lib/adminPath.js), jamais indexée.
  if (pathname.startsWith("/gestion-fh-9k27")) return ADMIN_META;
  if (pathname.startsWith("/blogue/")) return { ...BLOG_ARTICLE_META, path: pathname };
  return { ...(METAS[pathname] || METAS["/"]), path: pathname };
};
